import { DEFAULT_ICON_AVATAR } from "../../containers/autorizacion/utils/AutorizacionConstant";
import { DATE_FORMATS } from "../../utils/Constant";
import moment from "moment";
import { CODIGO_CONTRATO_OXIGENO, TIPO_PSS_NO_MEDICO_JIRA, PLAN_PDSS_JIRA, CANAL_OFV_JIRA } from "../../containers/ingreso/utils/IngresoConstant";

const exportedObject = {
  formCierreCuentasData: {
    numeroIngreso: "",
    secuencialIngreso: null,
    fechaSalida: null,
    motivoEgreso: "",
    frecuenciaCobertura: "1",
    montoReclamado: "",
    codigoCobertura: "",
    causaInternamiento: "",
    tipoPss: "",
    nombrePss: "",
    codigoPss: null,
    categoriaPss: null,
    numeroReclamacion: null,
    numeroPrecertificacion: null,
    tienePrecertificacion: false,
    descripcionEstatus: null,
    numeroAfiliado: "",
    cedula: "",
    nss: "",
    nombreAfiliado: "",
    edad: "",
    fechaServicio: moment(new Date()).format(DATE_FORMATS.middledash_ymd),
    tipoServicio: "",
    plan: "",
    codigoPlan: null,
    anio: null,
    compania: null,
    ramo: null,
    secuenciaPoliza: null,
    codigoAsegurado: null,
    numeroPlastico: null,
    secuenciaAsegurado: null,
    fechaNacimiento: null,
    sexo: null,
    estadoCivil: null,
    categoriaAfiliado: null,
    checkCirugia: null,
    foto: DEFAULT_ICON_AVATAR,
    showAlert: false,
    alertConfig: {},
    numeroIngresoBusqueda: "",
    anioBusqueda: "",
    showDetalleIngreso: false,
    showRequired: false,
    showModalProcedimientosPermitidos: false,
    showModalCalculadoraOxigeno: false,
    showModalMedicosParticipantes: false,
    aplicaExcepcion: false,
    procedimientos: [],
    procedimientosPermitidos: [],
    tieneMedicos: false,
    medicosParticipantes: [],
    tipoServicioOrigen: null,
    tarifaOxigeno: null,
    contratoOxigeno: CODIGO_CONTRATO_OXIGENO.LITRO,
    cantidadOxigeno: null,
    montoOxigeno: null,
    bloquearCamposOxigeno: false
  },
  formCierreCuentasLoading: false,

  formConsultaCierresCuentasData: {
    numeroReclamacion: "",
    numeroAfiliado: "",
    fechaInicio: "",
    fechaFin: "",
    fechaServicio: "",
    fechaSalida: "",
    dataCierres: null,
    showAlert: false,
    alertConfig: {},
  },

  formConsultaCierresCuentasLoading: false,

  consultarCierresCuentasLoading: false,

  consultarIngresoLoading: false,

  consultarDetalleCierreCuentaLoading: false,

  getProcedimientosPermitidosCierreCuentasLoading: false,

  validarProcedimientoCierreCuentasLoading: false,

  eliminarProcedimientoCierreCuentasLoading: false,

  consultarReclamantesLoading: false,

  cerrarCuentaClinicaLoading: false,

  getVoucherCierreCuentaLoading: false,

  calcularOxigenoLoading: false,

  formPacientesIngresadosData: {
    tipoDocumento: "",
    documento: "",
    numeroIngreso: "",
    codigoAsegurado: "",
    nombrePaciente: "",
    fechaIngreso: null,
    fechaSalida: null,
    pacientes: [],
    totalRegistros: 0,
    totalPaginas: 0,
    paginaActual: 1,
    tamanoPagina: 10,
    showAlert: false,
    alertConfig: {},
  },
  consultarPacientesIngresadosLoading: false,

  formHojaQuirurgicaData: {
    nombreAfiliado: "",
    numeroIngreso: "",
    fechaIngreso: "",
    diagnostico: "",
    numeroCarnet: "",
    tipoServicio: "",
    nombrePss: "",
    plan: PLAN_PDSS_JIRA,
    tipoPss: TIPO_PSS_NO_MEDICO_JIRA,
    codigoPss: "",
    fechaEgreso: null,
    motivoEgreso: "",
    zona: "",
    canal: CANAL_OFV_JIRA,
    correoElectronico: "",
    medicoTratantePrincipal: "",
    medicosAdicionales: [],
    comentarios: "",
    documentos: {
      hojaQuirurgica: null,
      hojaAnestesia: null,
      estudiosRealizados: null,
      historiaClinica: null,
      otros: null,
    },
    showRequired: false,
    showAlert: false,
    alertConfig: {},
  },
  camposHojaQuirurgicaData: null,
  obtenerCamposHojaQuirurgicaLoading: false,
  obtenerCamposHojaQuirurgicaError: null,
  crearSolicitudHojaQuirurgicaData: null,
  crearSolicitudHojaQuirurgicaLoading: false,
  crearSolicitudHojaQuirurgicaError: null,

  formSolicitudesHojaQuirurgicaData: {
    numeroCarnet: "",
    fechaDesde: moment().subtract(3, "months").format(DATE_FORMATS.middledash_ymd),
    fechaHasta: moment().format(DATE_FORMATS.middledash_ymd),
    fechaIngreso: null,
    numeroIngreso: "",
    servicio: "",
    estado: "",
    numeroSolicitud: "",
    solicitudes: [],
    totalRegistros: 0,
    totalPaginas: 0,
    paginaActual: 1,
    tamanoPagina: 10,
    showAlert: false,
    alertConfig: {},
  },
  buscarSolicitudesHojaQuirurgicaLoading: false,

  detalleSolicitudHojaQuirurgicaData: null,
  obtenerDetalleSolicitudHojaQuirurgicaLoading: false,
  obtenerDetalleSolicitudHojaQuirurgicaError: null,
};

export default exportedObject;
